import isEmpty from "lodash/isEmpty";
import isEqual from "lodash/isEqual";
import isNil from "lodash/isNil";
import useStorage from "PFCore/helpers/use_storage";
import { OrderOption, OrderOptionOrEmpty } from "PFTypes";
import { SetStateAction, useCallback, useEffect } from "react";

const STORAGE_OPTIONS = { expiresIn: 0 };

export type OrderStorage = {
  selectedOrder: OrderOptionOrEmpty;
  setSelectedOrder: (order: OrderOptionOrEmpty) => void;
  noOrderSelected: boolean;
};

const useStorageOrder = ({
  storagePrefix,
  defaultValue = {},
  options
}: {
  storagePrefix: string;
  defaultValue?: OrderOptionOrEmpty;
  options?: OrderOption[];
}): OrderStorage => {
  const [selectedOrder, setSelectedOrder] = useStorage<OrderOptionOrEmpty>(
    `${storagePrefix}_selectedOrder`,
    defaultValue,
    STORAGE_OPTIONS
  );

  const noOrderSelected = isEqual(selectedOrder, {}) || isNil(selectedOrder);

  // TODO: [ENG-2596] Double check with API if defaulting order is not needed before making API call
  useEffect(() => {
    if (isEmpty(options)) {
      return;
    }

    const isSelectedOptionAvailable = options!.some(({ name }) =>
      isEqual(name, (selectedOrder as OrderOption)?.name || [])
    );

    if (!isSelectedOptionAvailable) {
      setSelectedOrder(defaultValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options]);

  const handleOrderChange = useCallback(
    (order: SetStateAction<OrderOptionOrEmpty>) => {
      setSelectedOrder(order || "");
    },
    [setSelectedOrder]
  );

  return {
    selectedOrder,
    setSelectedOrder: handleOrderChange,
    noOrderSelected
  };
};

export default useStorageOrder;
